/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'

import columnsStructure from './columnsStructure'
import Table from './Table'

import './DataTable.scss'

export const DataTable = ({
  deleteOrderLinePopOut,
  itemData,
  updateOrderLineById,
  partnerOrderId,
  partnerOrderStatus,
  setDeleteOrderLinePopOut,
  isInternationalOrder,
  partnerCode,
  ...restProps
}) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const columns = useMemo(() => columnsStructure, [])

  /** Toaster Function */
  const notify = (message, type) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    }
  }
  const handleButtonClick = (rowDetails, mode) => {
    if (mode === 'edit') {
      const toBeUpdated = data.map((item) => {
        if (item.id === rowDetails.id) {
          return {
            ...item,
            showEditView: !item.showEditView,
          }
        }
        return {
          ...item,
          showEditView: false,
          warehouseSKU: item.originalValueWarehouseSKU,
        }
      })
      setData(toBeUpdated)
    }
    if (mode === 'update') {
      const price = parseFloat(rowDetails.totalPrice)
      const originalPrice = parseFloat(rowDetails.originalValueTotalPrice)
      const sku = rowDetails.warehouseSKU?.trim()
      const originalSku = rowDetails.originalValueWarehouseSKU?.trim()

      const isPriceChanged = price !== originalPrice
      const isSkuChanged = sku !== originalSku

      if (!isPriceChanged && !isSkuChanged) {
        // No changes, just close the editor
        const toBeUpdated = data.map((item) => {
          if (item.id === rowDetails.id) {
            return {
              ...item,
              showEditView: false,
            }
          }
          return item
        })
        setData(toBeUpdated)
        return
      }

      if (isNaN(price) || price === 0) {
        toast.error('Unit Price cannot be 0.00')
        return
      }

      updateOrderLineById({
        partnerOrderId,
        orderLineId: rowDetails.id,
        warehouseSKU: sku,
        totalPrice: price.toFixed(2),
      })

      const toBeUpdated = data.map((item) => {
        if (item.id === rowDetails.id) {
          return {
            ...item,
            showEditView: false,
            originalValueTotalPrice: price,
            originalValueWarehouseSKU: sku,
          }
        }
        return item
      })
      setData(toBeUpdated)
    }
  }

  const handleButtonCloseClick = (rowDetails) => {
    const toBeUpdated = data.map((item) => {
      if (item.id === rowDetails.id) {
        return {
          ...item,
          showEditView: false,
          warehouseSKU: item.originalValueWarehouseSKU,
          totalPrice: item.originalValueTotalPrice,
        }
      }
      return item
    })
    setData(toBeUpdated)
  }

  const handleInputChange = (rowDetails, value, field = 'totalPrice') => {
    const toBeUpdated = data.map((item) => {
      if (item.id === rowDetails.id) {
        return {
          ...item,
          [field]: value,
        }
      }
      return item
    })
    setData(toBeUpdated)
  }

  useEffect(() => {
    if (itemData?.length > 0) {
      const toBeUpdated = itemData.map((item) => ({
        ...item,
        showEditView: false,
        originalValueWarehouseSKU: item.warehouseSKU,
        originalValueTotalPrice: item.totalPrice,
      }))
      setData([...toBeUpdated])
    }
  }, [itemData])

  return (
    <div className='data-table w-full text-sm h-full' {...restProps}>
      <Table
        data={data}
        loading={loading}
        columns={columns}
        handleInputChange={handleInputChange}
        handleButtonClick={handleButtonClick}
        handleButtonCloseClick={handleButtonCloseClick}
        partnerOrderStatus={partnerOrderStatus}
        deleteOrderLinePopOut={deleteOrderLinePopOut}
        setDeleteOrderLinePopOut={setDeleteOrderLinePopOut}
        partnerCode={partnerCode}
        isInternationalOrder={isInternationalOrder}
      />
    </div>
  )
}

export default DataTable
